import axios from 'axios';

export function getApiErrorMessage(error) {
  const data = error?.response?.data ?? error?.data;

  if (typeof data === 'string' && data.trim()) {
    return data;
  }

  if (data && typeof data === 'object') {
    if (data.parent?.message) return data.parent.message;
    if (data.message) return data.message;
    if (data.name?.startsWith?.('Sequelize')) return data.name;
  }

  if (error?.message && error.message !== 'Network Error') {
    return error.message;
  }

  return 'Something went wrong!';
}

function isErrorPayload(data) {
  if (!data || typeof data !== 'object' || Array.isArray(data)) {
    return false;
  }

  if (typeof data.name === 'string' && data.name.startsWith('Sequelize')) {
    return true;
  }

  // Backend often does res.json(err) with HTTP 200
  if (data.message && data.stack && !('id' in data)) {
    return true;
  }

  return false;
}

let cd = window.localStorage.getItem('cd');
const defaultInstance = axios.create({
  baseURL: process.env.REACT_APP_API,
  headers: {
    Authorization: 'Bearer ' + cd,
  },
});

defaultInstance.interceptors.response.use(
  (response) => {
    if (isErrorPayload(response.data)) {
      const message = getApiErrorMessage({ response });
      const error = new Error(message);
      error.response = response;
      return Promise.reject(error);
    }

    return response;
  },
  (error) => {
    error.message = getApiErrorMessage(error);
    return Promise.reject(error);
  }
);

export default defaultInstance;
